import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei from "Types/IMei";
import _ from "lodash";

export const GET_COMPANIES = "[MEI] GET_COMPANIES";
export const GET_COMPANIES_SUCCESS = "[MEI] GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_FAILED = "[MEI] GET_COMPANIES_FAILED";

export const SET_VALUE = "[MEI] SET_VALUE";
export const CLEAR_VALUES = "[MEI] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getCompanies(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IMei[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_COMPANIES });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Mei?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_COMPANIES_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_COMPANIES_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_COMPANIES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
